(() => {
  'use strict';
  if (window.pmBfcmLanding) return;
  window.pmBfcmLanding = true;
  const controllers = new Map();
  let cleanNavigation = () => {};
  function attachNavigation() {
    cleanNavigation();
    const section = document.querySelector('.bfcm-nav-section');
    const nav = section?.querySelector('.bfcm-nav');
    if (!nav) return;
    const controller = new AbortController(), signal = controller.signal;
    const header = document.querySelector('.cc-header');
    let frame;
    const measure = () => {
      const rect = header?.getBoundingClientRect();
      const position = header ? getComputedStyle(header).position : '';
      const top = rect && ['sticky', 'fixed'].includes(position) ? Math.max(0, rect.bottom) : 0;
      document.documentElement.style.setProperty('--bfcm-nav-top', Math.ceil(top) + 'px');
      document.documentElement.style.setProperty('--bfcm-nav-height', Math.ceil(nav.getBoundingClientRect().height) + 'px');
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); };
    const observer = new ResizeObserver(schedule);
    observer.observe(nav);
    if (header) observer.observe(header);
    for (const event of ['scroll', 'resize', 'pageshow']) window.addEventListener(event, schedule, { passive: true, signal });
    if (header) header.addEventListener('transitionend', schedule, { signal });
    measure();
    cleanNavigation = () => {
      controller.abort(); observer.disconnect(); cancelAnimationFrame(frame);
      document.documentElement.style.removeProperty('--bfcm-nav-top');
      document.documentElement.style.removeProperty('--bfcm-nav-height');
      cleanNavigation = () => {};
    };
  }
  function attach() {
    attachNavigation();
    for (const [root, cleanup] of controllers) {
      if (!root.isConnected) { cleanup(); controllers.delete(root); }
    }
    document.querySelectorAll('discount-variant-cards').forEach(root => {
      if (!root.hasAttribute('data-bfcm-carousel') || controllers.has(root)) return;
      const track = root.querySelector('.discount-variant-cards__grid');
      const dots = root.querySelector('[data-bfcm-dots]');
      if (!track || !dots) return;
      const controller = new AbortController(), signal = controller.signal;
      const previous = root.querySelector('[data-bfcm-prev]'), next = root.querySelector('[data-bfcm-next]');
      const scrollTo = left => track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      const stride = () => track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0);
      const refresh = () => {
        const container = root.querySelector('.container');
        root.style.setProperty('--bfcm-carousel-center', (track.getBoundingClientRect().top - container.getBoundingClientRect().top + track.offsetHeight / 2) + 'px');
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const pages = max ? Math.ceil(max / stride()) + 1 : 1;
        if (dots.children.length !== pages) {
          dots.replaceChildren();
          for (let index = 0; index < pages; index++) {
            const dot = document.createElement('button');
            dot.type = 'button'; dot.dataset.page = index; dot.setAttribute('aria-label', `Show variants page ${index + 1}`);
            dots.append(dot);
          }
        }
        const active = Math.min(pages - 1, Math.round(track.scrollLeft / stride()));
        [...dots.children].forEach((dot, index) => {
          if (index === active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        previous.disabled = track.scrollLeft < 1;
        next.disabled = track.scrollLeft >= max - 1;
        root.querySelector('.bfcm-carousel-controls').hidden = max === 0;
      };
      previous.addEventListener('click', () => scrollTo(track.scrollLeft - stride()), {signal});
      next.addEventListener('click', () => scrollTo(track.scrollLeft + stride()), {signal});
      dots.addEventListener('click', event => {
        const dot = event.target.closest('[data-page]');
        if (dot) scrollTo(Number(dot.dataset.page) * stride());
      }, {signal});
      track.addEventListener('scroll', refresh, {signal, passive:true});
      const observer = new ResizeObserver(refresh); observer.observe(track);
      refresh(); controllers.set(root, () => { controller.abort(); observer.disconnect(); });
    });
  }
  attachNavigation();
  customElements.whenDefined('discount-variant-cards').then(attach);
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('shopify:section:unload', attach);
  document.addEventListener('shopify:section:reorder', attach);
  let scheduled = false;
  window.addEventListener('scroll', () => {
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const links = [...document.querySelectorAll('.bfcm-nav a')];
      let current = links[0];
      for (const link of links) {
        const target = document.querySelector(link.getAttribute('href'));
        if (target && target.getBoundingClientRect().top < innerHeight / 2) current = link;
      }
      for (const link of links) {
        if (link === current) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
      }
    });
  }, {passive:true});
})();
